import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { useState } from 'react'

import Ui from '../../ui'
import {
  error,
  initial,
  isError,
  isSuccess,
  loading,
  success,
} from '../../utils/remoteData'
import Spinner from '../Spinner'
import { ConfirmPayment } from './ConfirmPayment'

export function SetupIntentForm({ returnURL, message, onChange }) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [confirmSetupRequest, setConfirmSetupRequest] = React.useState(
    initial()
  )
  const formRef = React.useRef(null)

  const elements = useElements()
  const stripe = useStripe()

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!stripe || !elements) {
      return
    }
    setIsSubmitting(true)
    // Confirm payment on the client
    setConfirmSetupRequest(loading())
    try {
      const data = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: returnURL,
        },
        redirect: 'if_required',
      })
      setConfirmSetupRequest(success(data))
      if (onChange) {
        onChange()
      }
    } catch (err) {
      setConfirmSetupRequest(error(err.message))
    }
    setIsSubmitting(false)
  }

  return (
    <>
      {!isSuccess(confirmSetupRequest) && (
        <form
          id="payment-form"
          onSubmit={async (e) => {
            handleSubmit(e)
          }}
          ref={formRef}
        >
          <div className="mx-5">
            <div className="text-gray-700 text-sm mt-2">
              <span>{message}</span>
            </div>
            <div className="mt-4">
              <PaymentElement
                id="card-element"
                onReady={() => setIsLoading(false)}
              />
            </div>
            {isLoading ? (
              <div className="py-3 bg-white flex justify-center text-gray-700 text-sm">
                <Spinner color="onLight" size={20} />
              </div>
            ) : (
              <Ui.PrimaryButton
                className="w-100 mt-4 mb-2"
                disabled={isSubmitting}
                onClick={() => {
                  if (formRef.current) formRef.current.requestSubmit()
                }}
              >
                Submit
              </Ui.PrimaryButton>
            )}
          </div>
          {isError(confirmSetupRequest) && (
            <div className="flex flex-1 justify-center mt-3">
              <Ui.ErrorLabel label={confirmSetupRequest.error} />
            </div>
          )}
        </form>
      )}
      {isSuccess(confirmSetupRequest) && (
        <ConfirmPayment
          client_secret={confirmSetupRequest.data.setupIntent.client_secret}
          setup_intent={confirmSetupRequest.data.setupIntent.id}
        />
      )}
    </>
  )
}
export default SetupIntentForm
